module.exports = __webpack_public_path__ + "wod-of-death-logo.png?b5c461312357b148ae66b580e8b7587d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wod-of-death-logo.png
// module id = 30
// module chunks = 0